import { MenuIcon } from 'lucide-react';
import { forwardRef, useState, type HTMLAttributes } from 'react';
import MuseaLogo from '~/assets/musea-logo';
import { cn } from '~/lib/utils';
import { Button } from '../ui/button';
import MenuSheet from './menu-sheet';

const Menu = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    // state
    const [open, setOpen] = useState(false);
    // handlers
    const closeMenu = () => setOpen(false);
    // UI
    return (
      <div
        className={cn('sticky top-0 z-50 flex py-4 px-[14px] bg-background', className)}
        ref={ref}
        {...props}
      >
        <Button variant="ghost" size="icon" onClick={() => setOpen(value => !value)}>
          <MenuIcon size={24} className="stroke-primary" />
        </Button>
        <MuseaLogo className="ml-6" />
        <MenuSheet open={open} onOpenChange={value => setOpen(value)} closeMenu={closeMenu} />
      </div>
    );
  }
);
Menu.displayName = 'Menu';
export default Menu;
